import { render, staticRenderFns } from "./FeaturedIcon.vue?vue&type=template&id=996d7f36"
import script from "./FeaturedIcon.vue?vue&type=script&lang=ts"
export * from "./FeaturedIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports